<template>
<div>
    <div class="block" style="width:100%;height:100%">
        <div style="margin-bottom:5px">
            <el-date-picker
            v-model="starttime"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            type="datetime"
            placeholder="开始日期">
            </el-date-picker>
            <el-date-picker
            v-model="endtime"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期">
            </el-date-picker>
            <el-button @click="select" size="small" :loading="isaveing">查询</el-button>
        </div>
        <el-row :gutter="8" style="height:100%">
            <el-col :span="8" style="height:100%">
              <el-card class="box-card" style="height:100%">
                    <div slot="header" class="clearfix">
                        <span style="font-weight:600">API汇总</span>
                    </div>
                    <div class="text item spec">
                        <div style="column-count: 3;column-gap: 10px;">
                            <div  v-for="(item,index) in apiList" :key="index" style=" margin-bottom: 10px;break-inside: avoid;">
                                <el-card class="box-card" >
                                    <div  class="text item" style="cursor:pointer">
                                        <span style="display:block;font-size:12px;opacity:.6;font-weight:600" @click="clickTotal(item)">{{item.description}}</span>
                                        <span style="display:block;font-size:12px;opacity:.6" @click="clickTotal(item)"><i class="el-icon-star-on"></i>总数量:<span style="color:black;font-weight:600">{{item.totalnum}}</span></span>
                                        <span style="display:block;font-size:12px;opacity:.6" @click="clickSuss(item)"><i class="el-icon-star-on" style="color:green"></i>成功数量:<span style="color:green;font-weight:600">{{item.successnum}}</span></span>
                                        <span style="display:block;font-size:12px;opacity:.6" @click="clickFail(item)"><i class="el-icon-star-on" style="color:red"></i>失败数量:<span style="color:red;font-weight:600">{{item.errornum}}</span></span>
                                    </div>
                                </el-card>
                            </div>
                        </div>
                    </div>
              </el-card>
            </el-col>
            <el-col :span="16">
                <el-card class="box-card">
                    <div slot="header" class="clearfix" style="display:flex; justify-content:space-between">
                        <span style="font-weight:600">日志明细</span>
                    </div>
                    <div class="text item">
                        <el-row :gutter="2">
                            <el-col style="display:flex">
                                <el-input v-model="keywords" clearable size="small" @keyup.enter.native="keydown"  prefix-icon="el-icon-search" placeholder="请输入内容">
                                     <el-button slot="append" :loading="selisaveing" @click="keysearch" icon="el-icon-search"></el-button>
                                </el-input>
                            </el-col>
                            <!-- <el-col :span="4" class="spec1">
                                <el-menu
                                    :default-active="menusel"
                                    class="el-menu-vertical-demo"
                                    >
                                        <el-menu-item index="" @click="allApiDetail" :disabled ="manusaveing">
                                            <span slot="title">所有</span>
                                        </el-menu-item>
                                       <el-menu-item v-for="(item,index1) in apiSelList " 
                                           :key="index1" 
                                           :disabled ="manusaveing"
                                           @click="clickMenu(item)"
                                           :index="item.portname">
                                            <span slot="title">{{item.description}}</span>
                                        </el-menu-item>
                                </el-menu>
                            </el-col> -->
                            <el-col :span="24" class="spec1">
                                <el-table :data="apiDetails" 
                                    border 
                                    height="85%"
                                    style="margin:5px 0px"
                                    @cell-dblclick = "cellClick"
                                    :header-cell-style="{'text-algin':'center'}"
                                    :cell-style="{'text-algin':'center'}">
                                        <el-table-column
                                        prop="portname"
                                        label="接口描述"
                                        :formatter="namePort"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="reqid"
                                        label="请求号"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="reqtime"
                                        label="请求时间'"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="code"
                                        label="状态码"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                        prop="message"
                                        label="接口调用说明"
                                        >
                                        </el-table-column>
                                </el-table>
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="currentPage1"
                                    :page-sizes="[20,50,100,200]"
                                    :page-size.sync="pageSize"
                                    layout="total,sizes, prev, pager, next"
                                    :total="total">
                                </el-pagination>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </el-col>
        </el-row>
   </div>
   <apiDeatailList ref="apiDeatailList" :apiDetail='apiDetailData'></apiDeatailList>
</div>
</template>
<script>
import axios from 'axios'
import Utility from '@/components/mixin.js'
import Navbar from '@/components/Base/Navbar'
import apiDeatailList from './apiDetailList.vue'
export default {
    components:{
        Navbar,
        apiDeatailList
    },
    mixins: [Utility],
    data () {
        return {
            apiList:[],//接口汇总列表
            apiDetails:[],//明细表
            apiDetailData:{},//当前操作的明细
            currentPage1:0,
            pageSize:20,//当前页面大小
            starttime:this.localdate()+" 00:00:00",
            endtime:this.localdate()+" 23:59:59",
            total:0,
            token:'',
            cliclapi:"",//点击的api
            isaveing:false,//防抖
            manusaveing:false,//导航栏防抖
            level:'all',//日志级别
            keywords:'',//检索关键字
            selisaveing:false,
        }
    },
    created () {
        this.token = localStorage.getItem('token')
        this.initData()
       // this.initSelData()
        this.initDetail()
    },
    methods: {
        keysearch(){
            this.initDetail()
        },
        keydown(){
            this.initDetail()
        },
        clickTotal(item){
            this.cliclapi = item.portname
            this.level = 'all'
            this.initDetail()
        },
        clickFail(item){
            this.cliclapi = item.portname
            this.level = 'fail'
            this.initDetail()
        },
        clickSuss(item){
            this.cliclapi = item.portname
            this.level = 'success'
            this.initDetail()
        },
        // clickApi(item){
        //     //console.log(this.menusel);
        //     //console.log(item);
        //     this.cliclapi = item.portname
        //     this.level ='all'
        //     this.initDetail()
        // },
        namePort(row){
            let name = row.portname
            var des = this.apiList.find(data=>data.portname===name)
           // console.log(des);
           if(des){
               return des.description
           }
        },
        initData(){
            this.initSelData()
        },
        //时间筛选API列表
        initSelData(){
            this.isaveing = true
            axios.get('/mananger/port/statistics?start_time='+this.starttime+'&end_time='+this.endtime+'&token='+this.token).then(response=>{
                let res = response.data
               // console.log(res);
                 if(res.code===1){
                    this.apiList=res.data
                }else{
                   this.err_process(res.code, '[' + res.code + ']' + res.message)
                }
                this.isaveing = false
            }).catch(err => {
              this.isaveing = false
              console.error(err)
              this.err_process('AAAA', '获取数据异常:[AAAA]' + err)
            })
        },
        //请求明细接口
        initDetail(){
            this.selisaveing = true
            axios.get('/mananger/port/loginfo?start_time='+this.starttime
            +'&end_time='+this.endtime
            +'&portname='+this.cliclapi
            +'&keywords='+this.keywords
            +'&level='+this.level
            +'&pageidx='+this.currentPage1
            +'&pagesize='+this.pageSize
            +'&token='+this.token).then(response=>{
                let res = response.data
               // console.log(res);
                if(res.code===1){
                    this.apiDetails=res.data
                    this.total = this.apiDetails.length
                 }else{
                    this.err_process('AAAA',res.message)
                }
                 this.selisaveing = false
            }).catch(err => {
               this.selisaveing = false
              console.error(err)
              this.err_process('AAAA', '获取数据异常:[AAAA]' + err)
            })
        },
        select(){
            this.level ='all'
            //this.apiList = ''
            //console.log(this.starttime,this.endtime);
            this.initSelData()
            this.initDetail()
        },
        // //点击导航栏所有
        // allApiDetail(){
        //     this.menusel = ''
        //     this.initDetail()
        // },
        // //点击其他导航栏
        // clickMenu(item){
        //     console.log(item.portname);
        //     this.menusel = item.portname
        //     this.initDetail()
        // },
        //当前页号发生改变
        handleCurrentChange(){
            console.log(this.pageSize,this.currentPage1);
            this.initDetail()
        },
        //页面大小发生改变
        handleSizeChange(){
            console.log(this.pageSize,this.currentPage1);
            this.initDetail()
        },
        //双击表单行
        cellClick(row){
            console.log(row);
            this.apiDetailData = row
            this.$refs.apiDeatailList.dialogApiVisible = true
        }
    }
}
</script>
<style scoped>
>>>.el-card__body{
    padding: 5px !important;
}
>>>.el-card__header{
    padding: 10px;
} 
>>>.spec{
  height:calc(100vh - 210px);
  background-color:#fafafa;
  overflow-x:hidden;
}
.spec1{
  height:calc(100vh - 240px);
  background-color:#fafafa;
  overflow-x:hidden;
}
</style>